import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ViewTable from 'app/shared/view-table/view-table';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Button } from 'edozvola-frontend-lib/dist/ui/components';
import { PartyView } from 'app/edozvola/cases/parties/model/party.model';
import { deletePartyQuery, fetchPartiesQuery } from 'app/edozvola/cases/parties/service/party.queries';
import { TABLE_QUERY_KEYS } from 'app/config/constants';
import { getInvalidRowsForTable } from 'app/shared/util/validation-errors.util';
import { findAssigneeNamesLinkedToSelectedParty } from 'app/edozvola/cases/parties/service/party.service';
import { getCaseContext } from 'app/shared/util/context-util';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';

const PartyTable = ({ setParty, setReadOnly }) => {
  const { id } = useParams<{ id: string }>();
  const [idPartyToDelete, setIdPartyToDelete] = useState();
  const initialText = 'Jeste li sigurni da želite obrisati podatke?';
  const [deleteModalText, setDeleteModalText] = useState(initialText);
  const [deleteModalShown, setDeleteModalShown] = useState(false);
  const { sidebarItemPair } = getCaseContext();

  const invalidRowIds = getInvalidRowsForTable(TABLE_QUERY_KEYS.PARTIES_TABLE);

  const { mutate: deletePartyMutation, isPending: partyDeletionPending } = deletePartyQuery();

  const openDeleteDialog = async party => {
    setIdPartyToDelete(party.idParty);

    if (party.hasAssigneeLinkedOnlyToThisParty) {
      const names = await findAssigneeNamesLinkedToSelectedParty(party.idParty);
      setDeleteModalText(`Brisanjem stranke obrisat će se i njegov opunomoćenik: ${names}. Jeste li sigurni da želite obrisati podatke?`);
    } else {
      setDeleteModalText(initialText);
    }

    setDeleteModalShown(true);
  };

  const removeParty = () => {
    setDeleteModalShown(false);
    setDeleteModalText(initialText);
    deletePartyMutation(idPartyToDelete);
  };

  const openPartyForm = (idParty: number, readOnly: boolean) => {
    setParty(idParty);
    setReadOnly(readOnly);
  };

  const renderTableRow = (value: PartyView, partyIndex: number, totalItems: number) => {
    return (
      <tr key={partyIndex} className={invalidRowIds.includes(value.idParty) ? 'invalid-table-row' : ''}>
        <td>{value.name}</td>
        <td>{value.oibMb}</td>
        <td>{value.partyType}</td>
        <td>{value.address}</td>
        <td>{value.email}</td>
        <td>{value.fileInsight}</td>
        <td>
          <div className={'actions-container'}>
            {sidebarItemPair?.canView && (
              <TooltipWrapper message={'Pregledaj'}>
                <FontAwesomeIcon icon={'eye'} className={'icon-table'} onClick={() => openPartyForm(value.idParty, true)} />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canEdit && (
              <TooltipWrapper message={'Uredi'}>
                <FontAwesomeIcon icon={'pen-to-square'} className={'icon-table'} onClick={() => openPartyForm(value.idParty, false)} />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canDelete && (
              <TooltipWrapper message={'Obriši'}>
                <FontAwesomeIcon icon={'trash-alt'} className={'icon-table'} onClick={() => openDeleteDialog(value)} />
              </TooltipWrapper>
            )}
          </div>
        </td>
      </tr>
    );
  };

  return (
    <>
      <ViewTable
        renderTableRow={renderTableRow}
        noDataMessage={'Nema stranki'}
        initialPaginationColumn={'idParty'}
        fetchDataQuery={fetchPartiesQuery}
        fetchDataProps={[id]}
      >
        <ViewTableHeaderColumn renderSort sortKey={'name'} columnLabels={['Ime i prezime/Naziv']} width={'15%'} />
        <ViewTableHeaderColumn renderSort sortKey={'oibMb'} columnLabels={['OIB/MB']} width={'5%'} />
        <ViewTableHeaderColumn renderSort sortKey={'partyType'} columnLabels={['Vrsta stranke']} width={'10%'} />
        <ViewTableHeaderColumn renderSort sortKey={'address'} columnLabels={['Adresa']} width={'17%'}/>
        <ViewTableHeaderColumn renderSort sortKey={'email'} columnLabels={['Email']} width={'10%'} />
        <ViewTableHeaderColumn renderSort sortKey={'email'} columnLabels={['Uvid u spis']} width={'15%'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Akcije']} width={'5%'} />
      </ViewTable>
      <Modal scrollable isOpen={deleteModalShown} size={'lg'} toggle={() => setDeleteModalShown(false)} centered>
        <ModalHeader>
          <span>Brisanje stranke/opunomoćenika</span>
        </ModalHeader>
        <ModalBody>
          <div>{deleteModalText}</div>
        </ModalBody>
        <ModalFooter>
          <Button size={'lg'} label="Odustani" outline prependIcon={'times'} onClick={() => setDeleteModalShown(false)} />
          <Button size={'lg'} label="Obriši" color={'danger'} prependIcon={'trash'} onClick={removeParty} />
        </ModalFooter>
      </Modal>
    </>
  );
};

export default PartyTable;
